import { api } from "./api";

// ─── PIN endpoints ─────────────────────────────────────────────
export const listPinUsers = () => api.get("/auth/pin/users").then((r) => r.data);
export const pinSetup = (pin, domanda_recupero, risposta_recupero) =>
  api.post("/auth/pin/setup", { pin, domanda_recupero, risposta_recupero }).then((r) => r.data);
export const pinLogin = (email, pin) =>
  api.post("/auth/pin/login", { email, pin }).then((r) => r.data);
export const pinRecoveryQuestion = (email) =>
  api.get("/auth/pin/recovery-question", { params: { email } }).then((r) => r.data);
export const pinResetWithRecovery = (email, risposta_recupero, new_pin) =>
  api.post("/auth/pin/reset-with-recovery", { email, risposta_recupero, new_pin }).then((r) => r.data);

// ─── Admin user PIN management ─────────────────────────────────
export const togglePinLogin = (uid, abilitato) =>
  api.put(`/users/${uid}/toggle-pin`, { abilitato }).then((r) => r.data);
export const adminResetPin = (uid) =>
  api.post(`/users/${uid}/reset-pin`).then((r) => r.data);
export const listLoginAttempts = (limit = 200) =>
  api.get("/users/login-attempts", { params: { limit } }).then((r) => r.data);

// ─── Exports ──────────────────────────────────────────────────
export const downloadRitiriExcel = (params) =>
  api.get("/export/ritiri-excel", { params, responseType: "blob" }).then((r) => r.data);
export const downloadRinnoviPdf = (soglia) =>
  api.get("/export/rinnovi-pdf", { params: { soglia }, responseType: "blob" }).then((r) => r.data);

// ─── SMTP settings ────────────────────────────────────────────
export const getSmtpSettings = () => api.get("/settings/smtp").then((r) => r.data);
export const setSmtpSettings = (cfg) => api.put("/settings/smtp", cfg).then((r) => r.data);
export const testSmtpConnection = () => api.post("/settings/smtp/test").then((r) => r.data);
